import { render, staticRenderFns } from "./kv-input.vue?vue&type=template&id=b813d676"
import script from "./kv-input.vue?vue&type=script&lang=js"
export * from "./kv-input.vue?vue&type=script&lang=js"
import style0 from "./kv-input.vue?vue&type=style&index=0&id=b813d676&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports